import clientAxios from "../config/axios";
import tokenAuth from "../config/tokenAuth";
import { types } from "../types";
import { errorAlert} from "./alerts";
import { setLoading, removeLoading } from "./ui";
// import { removeError, setError, setLoading } from "./ui";

// function authenticatedUser() {
//   return async (dispatch) => {
//     try {
//       const token = localStorage.getItem("token");
//       if (token) {
//         tokenAuth(token);
//       }
//       const response = await clientAxios.get("/api/v1/auth");
//       console.log("userAuth", response);
//       dispatch({
//         type: types.getUser,
//         payload: response.data.user,
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   };
// }

// export const login = (dataUser) => {
//   return async (dispatch) => {
//     try {
//       const response = await clientAxios.post("/api/v1/auth", dataUser);
//       dispatch({
//         type: types.login,
//         payload: response.data,
//       });

//       authenticatedUser();
//       console.log(response.data);
//     } catch (error) {
//       console.log("error **Login", error);
//     }
//   };
// };

export const startLoginEmailPassword = (dataUser) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      const response = await clientAxios.post("/api/v1/auth", dataUser);//<-ACA

      dispatch(login(response));

      const token = localStorage.getItem("token");

      if (token) {
        tokenAuth(token);
      }

      const responseUser = await clientAxios.get("/api/v1/auth"); //<-ACA

      dispatch(removeLoading());
      
      dispatch(authenticated(responseUser));
    } catch (error) {
      // console.log("error **Login", error);
      // console.log(error.response.data);
      //mandaria un dispatch
      dispatch(

        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
      
    }
    dispatch(removeLoading());
  };
};

export const authenticathingUser = () => {
  return async (dispatch) => {
    // console.log("error")
    const token = localStorage.getItem("token");
    if (token) {
      tokenAuth(token);
    }
    try {
      const response = await clientAxios.get("/api/v1/auth");
      // console.log(response)
      dispatch(authenticated(response));
    } catch (error) {
      console.log(error);
    }
  };
};

export const logingOut = () => ({ type: types.logout });

export const login = (response) => ({
  type: types.login,
  payload: response.data,
});

export const authenticated = (response) => ({
  type: types.getUser,
  payload: response.data.user,
});
